import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box, Grid, MenuItem, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../../../commons/formik/formikTextField";
import FormikSelect from "../../../../../commons/formik/formikSelect";
import FormikTimePicker from "../../../../../commons/formik/formikTimePicker";
import DropZone from "../../../../forms/dropZone/dropZone";

const validationSchema = Yup.object().shape({
  horaLlegada: Yup.mixed().required("La hora de llegada es obligatoria"),
  idMotivo: Yup.number().required("El motivo es obligatorio"),
  observaciones: Yup.string().required("Las observaciones son obligatorias"),
});

const MarcarNegativoDialogPT = ({ open, handleClose, tramo, motivosNegativo, handleSubmit }) => {
  const [archivos, setArchivos] = useState([]);

  const onSubmit = async (values) => {
    const imagenes = archivos.map(a => ({
      Base64: a.value,
      MimeType: a.mimeType,
      Nombre: a.nombre
    }));

    let hora = values.horaLlegada;
    if (typeof hora === "object" && hora !== null) {
      if (hora.format) {
        hora = hora.format("HH:mm");
      } else {
        const h = hora.getHours().toString().padStart(2, '0');
        const m = hora.getMinutes().toString().padStart(2, '0');
        hora = `${h}:${m}`;
      }
    }

    handleSubmit({ ...values, horaLlegada: hora, imagenes });
  };

  if (!tramo) return null;

  let initialHora = null;
  if (tramo.hora) {
    const [h, m] = tramo.hora.split(":");
    const d = new Date();
    d.setHours(h, m, 0, 0);
    initialHora = d;
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#5b9bf5", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle1">MARCAR POSIBLE NEGATIVO - TRASLADO {tramo.nroTraslado}</Typography>
        <IconButton onClick={handleClose} sx={{ color: "#fff" }} size="small"><CloseIcon /></IconButton>
      </DialogTitle>

      <Formik
        initialValues={{
          horaLlegada: initialHora || "",
          idMotivo: "",
          observaciones: ""
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <DialogContent dividers>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Trabajador</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.trabajador} - DNI {tramo.documentoTrabajador}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Turno</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.fechaHoraTraslado && new Date(tramo.fechaHoraTraslado).toLocaleString()}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Recorrido</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.calleOrigen} {tramo.localidadOrigen} &rarr; {tramo.calleDestino} {tramo.localidadDestino}</Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} sx={{ '& .MuiFormControl-root': { width: '100%' } }}>
                  <FormikTimePicker
                    name="horaLlegada"
                    label="Hora de llegada *"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikSelect
                    name="idMotivo"
                    label="Motivo *"
                    variant="standard"
                    fullWidth
                  >
                    <MenuItem value="">Seleccionar...</MenuItem>
                    {motivosNegativo.map((motivo) => (
                      <MenuItem key={motivo.idMotivo} value={motivo.idMotivo}>
                        {motivo.descripcion}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField
                    name="observaciones"
                    label="Observaciones *"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ border: "1px solid #dde2e7", borderRadius: "4px", p: 2 }}>
                    <DropZone
                      files={archivos}
                      setFiles={(newFiles) => {
                        if (newFiles.length > 2) {
                          alert("Se permiten hasta 2 imágenes máximo.");
                          setArchivos(newFiles.slice(0, 2));
                        } else {
                          setArchivos(newFiles);
                        }
                      }}
                      configuration={{
                        oneFile: false,
                        maxFileSizeBytes: 5242880, // 5MB
                      }}
                      accept={{ "image/*": [".jpg", ".jpeg", ".png"] }}
                      dropzoneText="Arrastre o haga click aquí para adjuntar hasta 2 imágenes."
                    />
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={handleClose} color="primary" disabled={isSubmitting}>VOLVER</Button>
              <Button type="submit" variant="contained" color="error" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "MARCAR POSIBLE NEGATIVO"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default MarcarNegativoDialogPT;
